export const appImages = {
    logo: {
        favicon: '/favicon.ico',
        x192: "/logo192.png",
        x512: "/logo512.png"
    },
    undraw: {
        chatting: "/undraw/undraw_chatting_re_j55r.svg"
    }
};